import axios from "@/axios-service";
import { ResponseContent, responseContent, paginatedResponseContent, Page  } from "../types";
import { CreditTrustDTO } from "./types";

const MS_URL = "senana/api/analysis";
const responseParser = responseContent(CreditTrustDTO);


export const getByUuid = async (
  uuid: string,
  harvestSeason?: string,
  cropType?: string,
): Promise<ResponseContent<CreditTrustDTO>> => axios
  .get(`${MS_URL}/${uuid}/credit-trust`, { params: { harvestSeason, cropType } })
  .then(responseParser)
